import React, { useState, useEffect } from "react";
import { getReq } from "../middleware/AxiosApisCall";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading";
import TableData from "../Partials/TableData3";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  TablePagination,
  TextField,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {StyledTableCell,HeaderTableCell,StyledTableRow} from "../Partials/TableStyle"
function WarehouseStock() {
  const [tableData, setTableData] = useState();
  const [tableRefresh, setTableRefresh] = useState(0);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const path = "getAllWarehouseStocks";
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");
 
  const loadWarehouseStock = async () => {
    setLoading(true);
    const response = await getReq(path);
    if (response.data.length) {
      setLoading(false);
      setTableData(response.data);
      setTableRefresh(tableRefresh + 1);
    } else {
      setTableData(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadWarehouseStock();
  }, []);

  const warehouseNames = [...new Set(tableData?.map((item) => item.warehouse))];

  const handleWarehouseChange = (e) => {
    setLoading(true);
    const filtredWarehousedata = tableData.filter(
      (item) => item.warehouse === e.target.value
    );
    setFilteredProducts(filtredWarehousedata);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
 const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredData = filteredProducts.filter((item) => {
    return Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
  });

  
  const columnHeadings =
  filteredProducts.length > 0
      ? Object.keys(filteredProducts[0]).filter((key) => key !== "_id")
      : [];
  return (
    <React.Fragment>
      <div className="headingdiv">
        <span className="componet-title">Warehouse Stock </span>
        <div>
          <button onClick={() => navigate(-1)}>Back</button>
        </div>
      </div>
      <div className="input-lable-h-div" style={{ marginBottom: "30px" }}>
        <select onChange={handleWarehouseChange}>
          <option>Select Warehouse</option>
          {warehouseNames !== null ? (
            warehouseNames.map((warehouse, i) => {
              return <option key={i}>{warehouse}</option>;
            })
          ) : (
            <option>Warehouse Not found</option>
          )}
        </select>
      </div>
      <div className="componet-sub2-title">
        <div className="justi-spacebt">
          <span>
            Total {filteredData != null ? filteredData.length : 0}
          </span>
          <div className="search-div">
            Search : 
            <input
              value={searchQuery}
              onChange={handleSearch}
              variant="outlined"
              size="small"
              // className="search-field"
            />
          </div>
        </div>
      </div>
     
    
      {!loading ? (
        <TableContainer component={Paper}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <StyledTableRow >
                <HeaderTableCell>Sl.No</HeaderTableCell>
                {columnHeadings.map((heading, index) => (
                  <HeaderTableCell key={index} >
                    {heading.charAt(0).toUpperCase() + heading.slice(1)}
                  </HeaderTableCell>
                ))}
                
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => (
                  <StyledTableRow key={item._id} sx={{
                    backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white',
                  }}>
                    <StyledTableCell sx={{ textAlign:'center'}}>{page * rowsPerPage + index + 1}</StyledTableCell>
                    {columnHeadings.map((heading, i) => (
                      <StyledTableCell key={i}>{item[heading]}</StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      ) : (
        <Loading />
      )}
    </React.Fragment>
  );
}

export default WarehouseStock;
